import { Heart } from 'lucide-react';
import styles from './style.module.scss';

export const FeedLikeButton = ({ isLiked, onToggle, count = 0 }) => {
  const strokeColor = isLiked ? '#e74c3c' : '#999999';
  const fillColor = isLiked ? '#e74c3c' : '#ffffff';

  return (
    <button
      type="button"
      className={`${styles.likeButton} ${isLiked ? styles.liked : ''}`}
      onClick={onToggle}
      aria-label={isLiked ? 'Descurtir' : 'Curtir'}
    >
      <Heart
        size={20}
        className={styles.icon}
        stroke={strokeColor}
        fill={fillColor}
        strokeWidth={1.5}
      />
      <span className={styles.count}>{count}</span>
    </button>
  );
};
